import GlassView from './GlassView'

export default GlassView
